import { InformationSources } from './infosource';

export interface IPhone {
    type?: number;
    number?: string;
    extension?: string;
    id?: number;
    name?: string;
}

export interface IPhoneNumber {
    id?: number;
    type?: number;
    number?: string;
    isValid?: boolean;
    extension?: string;
    source: InformationSources;
    isPrimary?: boolean;
}

export interface IMemberPhoneNumber extends IPhoneNumber {
    memberId: string;
}

export class MemberPhone implements IMemberPhoneNumber {
    id?: number;
    memberId: string;
    type?: number;
    number?: string;
    isValid?: boolean;
    extension?: string;
    source: InformationSources;
    isPrimary?: boolean;
    verifiedOn? : string;
    verifiedByObjectId?: string;
    promotionFromId? : number;
    IsReassigned?: boolean;
    constructor(input: Partial<IMemberPhoneNumber>) {
        Object.assign(this, input);
    }

    setNumber(number: string) {
        this.number = number;
        return this;
    }
}

export class PhoneAssignmentResult {
    error?: string;
    isReassigned: boolean;
}
export class PendingPhone {
    id?: number;
    memberId: string;
    type?: number;
    number?: string;
    extension?: string;
    firstObserved?: string;
    firstObservedIn?: string;
    latestObserved?: string;
    latestObservedIn?: string;
    totalObserved?: string;
    actionedOn?: string;
    actionTaken?: string;
    actionedByObjectId?: string;
}

// export class MemberPhone {
//     isPrimary?: boolean;
//     phone: Phone;
//     extension: string;


//     constructor(obj: any)
//     constructor(id: number, memberId: string, type: number, number: string, extension: string, isPrimary: boolean, source?: InformationSources)
//     constructor(idOrObject: any, memberId?: string, type?: number, number?: string, extension?: string, isPrimary?: boolean, source?: InformationSources) {
//         const pivot = idOrObject || type;
//         if (typeof pivot === 'number' || typeof pivot === 'string') {
//             this.isPrimary = isPrimary;
//             this.phone = new Phone(idOrObject as number, memberId, type, number, true, extension);
//         } else if (idOrObject) {
//             const internal = idOrObject as MemberPhone;
//             this.isPrimary = internal.isPrimary;
//             this.phone = new Phone(internal.phone || internal);
//         } else {
//             this.phone = new Phone(0, memberId, type, number, true, extension, source);
//             this.isPrimary = isPrimary;
//         }
//     }

//     setNumber(number: string) {
//         if (this.phone) {
//             this.phone.number = number;
//         }
//         return this;
//     }
// }



export interface IPhoneNumberV2<T> {
    id?: T;
    type?: number;
    number?: string;
    extension?: string;

    toString(options?: IStringOptions): string;
}

export class PhoneNumberV2<T> implements IPhoneNumberV2<T>{
    id?: T;
    type?: number;
    number?: string;
    extension?: string;

    constructor(input: Partial<IPhoneNumberV2<T>>) {
        Object.assign(this, input);
    }

    toString(options?: IStringOptions): string {
        const config: IStringOptions = {... {extension: true, extensionLabel: 'x'}, ...options};

        const numberWithSeparators = (number: string) => {
            const clean = number.replace(/\D/g, '');
            if (clean.length >= 11) {
                const matches = clean.match(/(?<country>\d{1})(?<code>\d{3})(?<first>\d{3})(?<second>\d{4})/);
                return `+${matches.groups['country']} (${matches.groups['code']}) ${matches.groups['first']}-${matches.groups['second']}`;

            } else if (clean.length >= 10) {
                const matches = clean.match(/(?<code>\d{3})(?<first>\d{3})(?<second>\d{4})/);
                return `(${matches.groups['code']}) ${matches.groups['first']}-${matches.groups['second']}`;
            }
        }

        let result = this.number ? numberWithSeparators(this.number) : 'N/A';


        if (config.extension && (this.extension && this.extension.length > 0)) {
            result = result + ` ${config.extensionLabel}${this.extension}`;
        }

        return result;
    }

    setNumber(number: string) {
        this.number = number;
        return this;
    }
}

export interface IStringOptions{
    extension?: boolean;
     extensionLabel?: string;
}

export interface IPhoneType {
    label: string;
    value: string;
    id: number;
}

export const PhoneTypeIds = {
    RESIDENCE: 0,
    MOBILE: 1,
    OTHER: 2,
    FAX: 3
};

export const PhoneTypes: IPhoneType[] = [
    { label: 'Home', value: 'HOME', id: PhoneTypeIds.RESIDENCE },
    { label: 'Mobile', value: 'MOBL', id: PhoneTypeIds.MOBILE },
    { label: 'Other', value: 'OTHR', id: PhoneTypeIds.OTHER },
    { label: 'Fax', value: 'FAX', id: PhoneTypeIds.FAX },
];


export const PhoneNumberTypeIconMap = {
    [PhoneTypeIds.RESIDENCE]: 'fal fa-phone-rotary',
    [PhoneTypeIds.FAX]: 'fal fa-fax',
    [PhoneTypeIds.MOBILE]: 'fal fa-mobile-screen-button',
    [PhoneTypeIds.OTHER]: 'fal fa-phone-flip'
}
